import { Box, Skeleton, Stack } from '@mui/material';

const RouteFallback = () => (
  <Box
    sx={{
      minHeight: '100vh',
      bgcolor: '#F5F7FA',
    }}
  >
    <Box
      sx={{
        height: 64,
        px: { xs: 2, md: 4 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: '#fff',
        borderBottom: '1px solid #E5E7EB',
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Skeleton variant="rounded" width={180} height={28} />
        <Skeleton variant="text" width={110} height={24} />
      </Stack>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Skeleton variant="text" width={150} height={20} />
        <Skeleton variant="circular" width={30} height={30} />
      </Stack>
    </Box>

    <Box sx={{ px: { xs: 2, md: 4 }, py: 2.5 }}>
      <Stack direction="row" spacing={3} sx={{ mb: 3, flexWrap: 'wrap' }}>
        {Array.from({ length: 7 }, (_, index) => (
          <Skeleton key={index} variant="text" width={index === 0 ? 90 : 125} height={24} />
        ))}
      </Stack>
      <Skeleton variant="text" width={220} height={34} />
      <Skeleton variant="text" width={460} height={22} sx={{ mb: 2.5, maxWidth: '80%' }} />
      <Stack direction="row" spacing={1.5} sx={{ mb: 2.5, flexWrap: 'wrap' }}>
        {Array.from({ length: 5 }, (_, index) => (
          <Skeleton key={index} variant="rounded" width={180} height={48} />
        ))}
      </Stack>
      <Box sx={{ p: { xs: 1.5, md: 2.5 }, bgcolor: '#fff', border: '1px solid #D9E2EC', borderRadius: 2 }}>
        <Skeleton variant="text" width={260} height={28} />
        <Skeleton variant="text" width={420} height={20} sx={{ mb: 1.5, maxWidth: '80%' }} />
        <Skeleton variant="rounded" height={300} />
      </Box>
    </Box>
  </Box>
);

export default RouteFallback;
